import { render, staticRenderFns } from "./AbsencesDash.vue?vue&type=template&id=eb0d9c4e&"
import script from "./AbsencesDash.vue?vue&type=script&lang=js&"
export * from "./AbsencesDash.vue?vue&type=script&lang=js&"
import style0 from "./AbsencesDash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports